import React, { useState, useEffect } from "react";
import { useTheme } from "../contexts/ThemeContext";

const Hero2 = () => {
  const { mode } = useTheme();
  const [quote, setQuote] = useState(null);
  const category = "happiness";

  useEffect(() => {
    const fetchQuote = async () => {
      try {
        const response = await fetch(
          `https://api.api-ninjas.com/v1/quotes?category=${category}`,
          {
            method: "GET",
            headers: {
              "X-Api-Key": "EI7k//SNQ+9BJiF6j2J+jw==6rhTY5cYlzU9BysP", // Replace with your actual API key
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error(`Error: ${response.statusText}`);
        }

        const data = await response.json();
        setQuote(data[0]); // Assuming you want the first quote
      } catch (error) {
        console.error("Error fetching quote:", error);
      }
    };

    fetchQuote();
  }, [category]);

  const text = quote?.quote || "Honesty is the best policy";

  return (
    <div
      className={`mt-4 p-4 ${
        mode === "light"
          ? "bg-white text-gray-900"
          : "bg-gray-900 text-gray-200"
      }`}
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        <a
          href="https://github.com/manish-terminal"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-gray-800 p-6 rounded-xl shadow-lg transition-transform transform hover:scale-105"
        >
          <h4 className="text-xl font-bold text-white">GitHub</h4>
          <img
            src="https://cdn-icons-png.flaticon.com/512/25/25231.png" // GitHub logo
            alt="GitHub Logo"
            className="w-10 h-10 my-2"
          />
          <p className="mt-2 text-white">My projects</p>
        </a>
        <a
          href="https://x.com/firsegupta"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-[#1DA1F2] p-6 rounded-xl shadow-lg transition-transform transform hover:scale-105"
        >
          <h4 className="text-xl font-bold text-white">
            X(Previously Twiiter)
          </h4>
          <img
            src="https://icon2.cleanpng.com/20240119/phb/transparent-x-icon-black-and-white-x-in-the-1710888893456.webp" // Twitter logo
            alt="Twitter Logo"
            className="w-10 h-10 my-2"
          />
          <p className="mt-2 text-white">(Discuss here :)</p>
        </a>
        <a
          href="https://www.instagram.com/manish.react/"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-gradient-to-r from-[#D62976] to-[#F77737] p-6 rounded-xl shadow-lg transition-transform transform hover:scale-105"
        >
          <h4 className="text-xl font-bold text-white">Instagram</h4>
          <img
            src="https://cdn-icons-png.flaticon.com/512/87/87390.png" // Instagram logo
            alt="Instagram Logo"
            className="w-10 h-10 my-2"
          />
          <p className="mt-2 text-white">Follow my journey!</p>
        </a>
        <a
          href="https://www.linkedin.com/in/manish-gupta-a074a6254/"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-[#0077B5] p-6 rounded-xl shadow-lg transition-transform transform hover:scale-105"
        >
          <h4 className="text-xl font-bold text-white">LinkedIn</h4>
          <img
            src="https://cdn-icons-png.flaticon.com/512/61/61109.png" // LinkedIn logo
            alt="LinkedIn Logo"
            className="w-10 h-10 my-2"
          />
          <p className="mt-2 text-white">Connect with me!</p>
        </a>
        <div className="bg-indigo-600 p-6 rounded-xl shadow-lg transition-transform transform hover:scale-105 col-span-1 sm:col-span-2 lg:col-span-3">
          <p className="text-lg text-white">{text}</p>
          {quote && (
            <h6 className="mt-2 text-white text-sm">— {quote.author}</h6>
          )}
        </div>
      </div>
    </div>
  );
};

export default Hero2;
